import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@environments/environment';
import {GenericHttpService} from '@core/services';
import {map} from 'rxjs/operators';
import {SignInResult} from '@app/+auth/shared/interfaces';
import {BehaviorSubject} from 'rxjs';
import {AuthService} from '@app/+auth/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ParentService extends GenericHttpService<any> {


  isVerify = new BehaviorSubject<boolean>(this.isVerified);
  private readonly THERAPIST_VERIFIED = '_therapistVerified';


  constructor(httpClient: HttpClient, private authService: AuthService) {
    super(httpClient, environment.apiUrl, 'auth');
  }

  saveGabadoo(gabadooDetails) {
    super.endpoint = 'parent';
    return super.post(gabadooDetails, 'createGabadoo');
  }

  updateGabadoo(gabadooDetails) {
    super.endpoint = 'parent';
    return super.post(gabadooDetails, 'updateGabadoo');
  }

  continueGabadoo(gabadooDetails) {
    super.endpoint = 'parent';
    return super.post(gabadooDetails, 'continueGabadoo');
  }

  uniqueGabadooFromTherapist(gabadooDetails) {
    super.endpoint = 'parent';
    return super.post(gabadooDetails, 'createUniqueGabadooFromTherapist');
  }

  saveChildBasicInfo(child) {
    super.endpoint = 'parent';
    return super.post(child, 'saveChildBasicInfo');
  }

  updateChildBasicInfo(child) {
    super.endpoint = 'parent';
    return super.post(child, 'updateChildBasicInfo');
  }

  saveChildPicture(media, id) {
    const formData: FormData = new FormData();
    formData.append('childPic', media);
    formData.append('childId', id);

    const url = environment.apiUrl + '/parent/saveChildPicture';
    const tokenvalue = this.authService.tokenValue;
    const allTokenStore = JSON.parse(localStorage.getItem('_token'));
    let refreshToken = '';
    if (allTokenStore) {
      refreshToken = allTokenStore.refreshToken;
    }
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<any>(url, formData,
      {
        observe: 'response', headers: {
          Authorization: `Bearer ${tokenvalue.accessToken}`,
          refreshtoken: refreshToken
        },
      });
  }

  uploadNewGabadoo(child) {
    super.endpoint = 'parent';
    return super.post(child, 'createGabadoo');

  }

  saveGabadooMedia(allMediaDetails, gabadooId, childInfoId, alreadyUploadedData, audio) {
    // Append formdata
    const formData: FormData = new FormData();
    formData.append('gabadooId', gabadooId);
    formData.append('childInfoId', childInfoId);
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < allMediaDetails.length; i++) {
      formData.append('media', allMediaDetails[i]);
    }
    formData.append('alreadyUploadedData', JSON.stringify(alreadyUploadedData));
    formData.append('audio', audio);
    // Url to upload
    const url = environment.apiUrl + '/parent/uploadMediaAudio';
    const tokenvalue = this.authService.tokenValue;
    const allTokenStore = JSON.parse(localStorage.getItem('_token'));
    let refreshToken = '';
    if (allTokenStore) {
      refreshToken = allTokenStore.refreshToken;
    }
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<any>(url, formData,
      {
        observe: 'response', headers: {
          Authorization: `Bearer ${tokenvalue.accessToken}`,
          refreshtoken: refreshToken

        },
      });
  }

  // Deleted selected file by parent
  deleteSelectedMediaFromS3(dataToSend) {
    super.endpoint = 'parent';
    return super.post(dataToSend, 'deleteMediaSelectedByParent');
  }

  // Personal Detail save
  savePersonalDetails(personalDetails) {
    super.endpoint = 'therapist';
    return super.post(personalDetails, 'savePersonalDetails');
  }

  getChildInfo() {
    super.endpoint = 'parent';
    return super.get('getChildInfo');
  }

  getChildInfoById(childInfoId) {
    super.endpoint = 'parent';
    return super.post(childInfoId, 'getChildInfoById');
  }

  getAreasOfFocus() {
    super.endpoint = 'parent';
    return super.get('getAreasOfFocus');
  }

  getDiagnosisOptions() {
    super.endpoint = 'parent';
    return super.get('getDiagnosisOptions');
  }

  getAllGabadooReviews() {
    super.endpoint = 'parent';
    return super.get('getAllGabadooReviews');
  }

  saveProfessionalDetails(professionalDetails) {
    super.endpoint = 'therapist';
    return super.post(professionalDetails, 'saveProfessionalDetails');
  }

  getSelectedReviewDetails(gabadooId) {
    super.endpoint = 'parent';
    return super.post(gabadooId, 'getSelectedGabadooDetails');
  }

  getSelectedGabadooDetailsInPlan(gabadooId) {
    super.endpoint = 'parent';
    return super.post(gabadooId, 'getSelectedGabadooDetailsInPlan');
  }

  getSelectedTherapistDetails(therapistUserId) {
    super.endpoint = 'parent';
    return super.post(therapistUserId, 'getSelectedTherapistDetails');
  }


  getSelectedChildDetails(childInfoId) {
    super.endpoint = 'parent';
    return super.post(childInfoId, 'getChildInfoById');
  }


  getAllParentSubmittedGabadooDetails(){
    super.endpoint = 'parent';
    return super.get('getAllParentSubmittedGabadooDetails');
  }

  submitSelectedGabadoo(infoToSubmit){
    super.endpoint = 'parent';
    return super.post(infoToSubmit, 'submitGabadooReview');
  }

  submitGabadooReviewForContinue(infoToSubmit){
    super.endpoint = 'parent';
    return super.post(infoToSubmit, 'submitGabadooReviewForContinue');
  }

  submitGabadooReviewForUniqueLink(infoToSubmit){
    super.endpoint = 'parent';
    return super.post(infoToSubmit, 'submitGabadooReviewForUniqueLink');
  }

  uploadRequireDocuments(idProofFile, regProofFile, addressProofFile, policeClearProofFile, insuranceProofFile, otherDocumentProofFile) {
    const formData: FormData = new FormData();
    formData.append('idProof', idProofFile);
    formData.append('regProof', regProofFile);
    formData.append('addressProof', addressProofFile);
    formData.append('policeClearProof', policeClearProofFile);
    formData.append('insuranceProof', insuranceProofFile);
    formData.append('otherDocumentProof', otherDocumentProofFile);

    const url = environment.apiUrl + '/therapist/saveUploadedDocuments';

    const tokenvalue = this.authService.tokenValue;
    const allTokenStore = JSON.parse(localStorage.getItem('_token'));
    let refreshToken = '';
    if (allTokenStore) {
      refreshToken = allTokenStore.refreshToken;
    }
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<any>(url, formData,
      {
        observe: 'response', headers: {
          Authorization: `Bearer ${tokenvalue.accessToken}`,
          refreshtoken: refreshToken

        },
      });
  }

  bookInterviewSlot(slotInformation) {
    super.endpoint = 'therapist';
    return super.post(slotInformation, 'bookInterviewSlot');
  }

  getPendingGabadooReviews() {
    super.endpoint = 'parent';
    return super.get('getAllPendingGabadoos');
  }

  getActiveGabadooReviews() {
    super.endpoint = 'parent';
    return super.get('getAllActiveGabadoos');
  }

  getCompletedGabadooReviews() {
    super.endpoint = 'parent';
    return super.get('getAllCompletedGabadoos');
  }


  // Observable
  private get isVerified(): boolean {
    return false;
  }


  // Get selected user information for parent profile
  getUserInformation(){
    super.endpoint = 'parent';
    return super.get('getUserInformationForParentProfile');
  }

  // Update parent personal information
  updateParentPersonalInformation(personalInformation) {
    super.endpoint = 'parent';
    return super.post(personalInformation, 'updateParentPersonalInformation');
  }

  // Deleted selected children profile
  deleteSelectedChildrenProfile(childId) {
    super.endpoint = 'parent';
    return super.post(childId, 'makeSelectedChildrenProfileInactive');
  }

  // Get all child information for parent
  getAllChildProfileInformation(){
    super.endpoint = 'parent';
    return super.get('getAllChildrensProfile');
  }

  // Update new password
  updateNewPassword(passwordData){
    super.endpoint = 'parent';
    return super.post(passwordData, 'update-password');
  }

  // Ask question to therapist
  askQuestionToTherapist(dataToAsk) {
    super.endpoint = 'parent';
    return super.post(dataToAsk, 'askTherapistQuestion');
  }

  // Update the gaba badge
  updateBadgeStatusInGabadooReview(gabadooId){
    super.endpoint = 'parent';
    return super.post(gabadooId, 'updateBadgeStatusInGabadooReviewForParent');
  }

  // Payment Gateway stripe

  paymentSuccessInformation(checkoutSessionId) {
    super.endpoint = 'parent';
    return super.post(checkoutSessionId, 'paymentSuccess');
  }

  accountAvailableCreditInformation() {
    super.endpoint = 'parent';
    return super.get('getAccountAvailableCreditInformation');
  }

  // Fetch the published key
  getPublishKeyForStripe() {
    super.endpoint = 'parent';
    return super.get('getStripePublishedKey');
  }

  // Get customer ID for subscribed customer
  getCustomerIdForSubscribedCustomer() {
    super.endpoint = 'parent';
    return super.get('getCustomerIdForSubscribedCustomer');
  }

  // Manage User Subscription
  goTomanageCustomerSubscription(customerId) {
    super.endpoint = 'parent';
    return super.post(customerId, 'manageCustomerSubscription');
  }
}
